import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const laboratoriesApi = {
    getLaboratories: (): Observable<Dtos.GetLaboratoriesResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratories = new Dtos.GetLaboratories();

        //Send request.
        const response: Promise<Dtos.GetLaboratoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryById: (id: number): Observable<Dtos.GetLaboratoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryById = new Dtos.GetLaboratoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setLaboratory: (laboratory: Dtos.Laboratory): Observable<Dtos.SetLaboratoryResponse> => {

        let request: Dtos.SetLaboratory = new Dtos.SetLaboratory();

        request.laboratory = laboratory;

        // send request
        const response: Promise<Dtos.SetLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createLaboratory: (): Observable<Dtos.CreateLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.CreateLaboratory = new Dtos.CreateLaboratory();

        //Send request.
        const response: Promise<Dtos.CreateLaboratoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateLaboratory: (laboratory: Dtos.Laboratory): Observable<Dtos.ValidateLaboratoryResponse> => {

        let request: Dtos.ValidateLaboratory = new Dtos.ValidateLaboratory();

        request.laboratory = laboratory;

        // send request
        const response: Promise<Dtos.ValidateLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    }
}